/** @jsx jsx */
import { jsx } from '@emotion/core';
import { B50 } from '@atlaskit/theme/colors';
import { Frame } from '../components/Frame';
import { Thumbnail } from '../components/Thumbnail';
import { Provider } from '../components/Provider';
import { Name } from '../components/Name';
import { Byline } from '../components/Byline';
import { ActionList } from '../components/ActionList';
import { Content } from '../components/Content';
import { containerCentredStyles, CelebrationImage } from '../utils/constants';
export var UnauthorizedView = function (_a) {
    var _b = _a.context, context = _b === void 0 ? { text: '' } : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.actions, actions = _d === void 0 ? [] : _d, testId = _a.testId;
    return (jsx(Frame, { isSelected: isSelected, testId: testId },
        jsx(Content, null,
            jsx("div", null,
                jsx(Name, { testId: testId ? testId + "-name" : undefined, name: "Get more out of your links", isLeftPadded: false }),
                jsx(Byline, { testId: testId ? testId + "-byline" : undefined, text: "Make these link previews more breathtaking by connecting " + context.text + " to your Atlassian products." })),
            jsx("div", { css: containerCentredStyles },
                jsx(Provider, { name: context.text, iconUrl: context.icon }),
                jsx(ActionList, { items: actions }))),
        jsx(Thumbnail, { src: CelebrationImage, color: B50, testId: testId ? testId + "-thumb" : undefined })));
};
//# sourceMappingURL=UnauthorizedView.js.map